import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Papa } from 'ngx-papaparse';
import { CSVTicket } from 'src/app/models/ticket/ticket.model';
import { OrderCsvDataRow } from 'src/app/orders-table/models';

@Component({
  selector: 'app-csv-download',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `@if (iconOnly) {
      <button class="csv-download" (click)="downloadCSV(csvData)">
        <div class="custom-icon csv">csv icon</div>
      </button>
    } @else {
      <button class="secondary-button" (click)="downloadCSV(csvData)">
        <mat-icon svgIcon="csv_file" class="!h-[20px] !w-[20px]"></mat-icon>
        Download
      </button>
    } `,
  standalone: false,
})
export class CSVDownloadComponent implements OnInit {
  @Input() csvData: CSVTicket[] | OrderCsvDataRow[] | any[];

  @Input() fileName: string;

  @Input() iconOnly: boolean = true;

  constructor(
    private papa: Papa,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.matIconRegistry.addSvgIcon(
      `csv_file`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `/assets/images/icons/csv-icon.svg`,
      ),
    );
  }

  downloadCSV(data): void {
    const csvFile: string = this.fileName;
    const csvUnparse = this.papa.unparse(data);
    const csvBlob = new Blob([csvUnparse], { type: 'text/csv;charset=utf-8;' });
    const csvURL = window.URL.createObjectURL(csvBlob);
    const tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', csvFile);
    tempLink.click();
  }
}
